'use client'
import Login2 from './login/page';

const Log = () => {

  return (
    <Login2 />
  )
}

export default Log;
